module.exports = __webpack_public_path__ + "static/media/gallery_05.129cb373.jpg";